import React, { useState, useEffect } from "react";
import DataTable from "../components/DataTable";
import SnackbarAlert from "../components/SnackbarAlert";
import { Box, TextField, Tooltip, Typography, Button, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, MenuItem, Chip, Switch, FormControlLabel } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
export default function Staff() {
    const [datasource, setDatasource] = useState([]);
    const [search, setSearch] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [editState, setEditState] = useState(null);
    const [userName, setUserName] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [userPassword, setUserPassword] = useState("");
    const [userRole, setStaffRole] = useState("");
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        fetchStaffData();
    }, []);
    const fetchStaffData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "staff";
            const response = await makeRequest("get", url);
            if (response) {
                setDatasource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const openAddModal = () => {
        setEditState(null);
        setUserName("");
        setMobileNumber("");
        setUserPassword("");
        setStaffRole("");
        setOpenModal(true);
    };
    const handleEdit = (data) => {
        setEditState(data);
        setUserName(data?.staff_name);
        setMobileNumber(data?.staff_mobilenumber);
        setUserPassword("");
        setStaffRole(data?.role);
        setOpenModal(true);
    };
    const handleClose = () => {
        setOpenModal(false);
        setUserName("");
        setMobileNumber("");
        setUserPassword("");
        setStaffRole("");
    };
    const handleSave = async () => {
        if (!userName.trim() && !userName.trim() && !userPassword && !userRole) {
            setMessage("All Fileds are Required");
            setSnackbar(true);
            return;
        }
        setLoading(true);
        try {
            if (editState) {
                const staffEditData = {
                    staff_name: userName,
                    staff_mobilenumber: mobileNumber,
                    password: userPassword,
                    role: userRole
                };
                try {
                    let url = webEndPoint + "staff/" + editState.rfId;
                    const response = await makeRequest("put", url, staffEditData);
                    if (response) {
                        setLoading(false);
                        setMessage("Staff Details Updated Successfully");
                    }
                } catch (err) {
                    if (err?.message) {
                        setMessage(err.message);
                    } else {
                        setMessage("Something went wrong");
                    }
                } finally {
                    setLoading(false);
                }
            } else {
                const staffAddData = {
                    staff_name: userName,
                    staff_mobilenumber: mobileNumber,
                    password: userPassword,
                    role: userRole
                };
                try {
                    let url = webEndPoint + "staff";
                    const response = await makeRequest("post", url, staffAddData);
                    if (response) {
                        setLoading(false);
                        setMessage("Staff Details Added Successfully");
                    }
                } catch (err) {
                    if (err?.message) {
                        setMessage(err.message);
                    } else {
                        setMessage("Something went wrong");
                    }
                } finally {
                    setLoading(false);
                }
            }
            fetchStaffData();
            setSnackbar(true);
            setOpenModal(false);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleToggleStatus = async (item) => {
        const newStatus = item?.isActive === 0 ? 1 : 0;
        try {
            setLoading(true);
            let url = webEndPoint + "staff/" + item.rfId + "/status";
            const payload = {
                isActive: newStatus
            };
            const response = await makeRequest("patch", url, payload);
            if (response) {
                setMessage(
                    newStatus === 0 ? "Staff Enabled Successfully" : "Staff Disabled Successfully"
                );
                setSnackbar(true);
                fetchStaffData();
            }
        } catch (err) {
            console.error(err);
            setMessage("Failed to update status");
            setSnackbar(true);
        } finally {
            setLoading(false);
        }
    };
    const filteredState = datasource?.filter((d) =>
        d?.staff_name?.toLowerCase().includes(search?.toLowerCase()) || d?.staff_mobilenumber?.toLowerCase().includes(search?.toLowerCase())
    );
    const columns = ["S.No", "Staff Name", "Mobile Number", "Role", "Login Status", "Action"];
    const rows = filteredState?.map((item, index) => [index + 1, item.staff_name, item.staff_mobilenumber, item?.role,
    <Switch checked={item?.isActive === 0} onChange={() => handleToggleStatus(item)} color="success" />,
    <Box>
        <Tooltip title="Edit Staff Details">
            <Button variant="contained" color="primary" onClick={() => handleEdit(item)}>Edit</Button>
        </Tooltip>
    </Box>
    ]);
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 500 }}>Staff</Typography>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "100%", }}>
                <TextField label="Search Staff Name / Mobile Number" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "70%", md: 600 } }} />
                <Button variant="contained" startIcon={<AddIcon />} onClick={openAddModal} sx={{ width: { xs: "100%", sm: "auto" }, }}>Add Staff</Button>
            </Box>
            <DataTable columns={columns} rows={rows} />
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
            <Dialog open={openModal} onClose={handleClose} fullWidth maxWidth="sm">
                <DialogTitle> {editState ? "Edit Staff" : "Add Staff"}</DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    <TextField label="Staff Name" value={userName} onChange={(e) => setUserName(e.target.value)} sx={{ mt: 1 }} fullWidth />
                    <TextField label="Staff Mobile Number" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} sx={{ mt: 1 }} fullWidth />
                    <TextField label="Login Password" value={userPassword} onChange={(e) => setUserPassword(e.target.value)} sx={{ mt: 1 }} fullWidth />
                    <TextField select label="Staff Role" value={userRole} onChange={(e) => setStaffRole(e.target.value)} fullWidth>
                        <MenuItem value="Admin">Admin</MenuItem>
                        <MenuItem value="Staff">Staff</MenuItem>
                    </TextField>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" onClick={handleSave}>Save</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}